<template>
  <div>
      <Navbar />

    <h1>Progress Report</h1>
    <!-- Add your content here -->
  </div>
</template>

<script>
import Navbar from'@/components/NavbarComponent'

export default {
  name: 'ProgressReportView',
  component: {
    Navbar
  },
  mounted() {
    window.scrollTo(0, 0);
    },
}
</script>

<style scoped>
</style>
